import { useBreakpoints } from '@cbhq/cds-web/hooks/useBreakpoints';
import { VStack } from '@cbhq/cds-web/layout/VStack';

import { ThemeOverride } from '../ProfileMenu/components/ThemeOverride';

import { HelpMenuDropdownContent } from './HelpMenuDropdownContent';

export function HelpMenuDropdown() {
  const { isPhone } = useBreakpoints();

  return (
    <ThemeOverride>
      <VStack
        borderRadius={400}
        minWidth={isPhone ? undefined : '375px'}
        width="100%"
        height="100%"
        maxHeight={isPhone ? undefined : '80vh'}
        background="bg"
      >
        <HelpMenuDropdownContent />
      </VStack>
    </ThemeOverride>
  );
}
